import axios from 'axios';
import authActions from '../actions/auth';
import userActions from '../actions/user';
import organizationActions from '../actions/organization';
import namespace from '../namespace';

export default {
	namespaced: true,
	state: {
		accessToken: localStorage.getItem('access_token') || '',
		refreshToken: localStorage.getItem('refresh_token') || '',
	},
	mutations: {
		[authActions.LOGIN]: (state, { accessToken, refreshToken }) => {
			state.accessToken = accessToken;
			state.refreshToken = refreshToken;
		},
		[authActions.LOGOUT]: (state) => {
			state.accessToken = '';
			state.refreshToken = '';
		},
		[authActions.REFRESH_TOKEN]: (state, { accessToken, refreshToken }) => {
			state.accessToken = accessToken;
			state.refreshToken = refreshToken;
		},
	},
	actions: {
		[authActions.LOGIN]: async ({ commit, dispatch, rootState }, { email, password }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'login');
				const response = await axios.post(link.href, { email, password });

				const { user, accessToken, refreshToken } = response.data;
				localStorage.setItem('access_token', accessToken);
				localStorage.setItem('refresh_token', refreshToken);

				commit(authActions.LOGIN, { accessToken, refreshToken });
				dispatch(`${namespace.USER}/${userActions.SET_USER}`, user, { root: true });				
			} catch (error) {
				localStorage.clear();

				throw error;
			}
		},
		[authActions.REGISTER]: async ({ rootState }, newUser) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'register');
				await axios.post(link.href, newUser);
			} catch (error) {
				localStorage.clear();

				throw error;
			}
		},
		[authActions.LOGOUT]: ({ commit, dispatch }) => {
			commit(authActions.LOGOUT);
			dispatch(`${namespace.USER}/${userActions.CLEAR}`, null, { root: true });
			dispatch(`${namespace.ORGANIZATION}/${organizationActions.CLEAR}`, null, { root: true });
			localStorage.clear();
		},
		[authActions.CONFIRM]: async ({ rootState }, confirmation) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'confirm_email');
				await axios.put(link.href, confirmation);
			} catch (error) {
				throw error;
			}
		},
		[authActions.REFRESH_TOKEN]: async ({ commit, state, rootState }) => {
			const refreshTokenInfo = {
				accessToken: state.accessToken,
				refreshToken: state.refreshToken,
			};

			try {
				const link = rootState.root.links.find(x => x.rel === 'refresh_token');
				const response = await axios.post(link.href, refreshTokenInfo);

				const { accessToken, refreshToken } = response.data;
				localStorage.setItem('access_token', accessToken);
				localStorage.setItem('refresh_token', refreshToken);

				commit(authActions.REFRESH_TOKEN, { accessToken, refreshToken });
			} catch (error) {
				localStorage.clear();

				throw error;
			}
		},
		[authActions.FORGOT_PASSWORD]: async ({ rootState }, forgotPassword) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'forgot_password');
				await axios.put(link.href, forgotPassword);
			} catch (error) {
				throw error;
			}
		},
		[authActions.RESET_PASSWORD]: async ({ rootState }, resetPassword) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'reset_password');
				await axios.put(link.href, resetPassword);
			} catch (error) {
				throw error;
			}
		},
	},
	getters: {
		AccessToken: state => state.accessToken,
		RefreshToken: state => state.refreshToken,
		IsAuthenticated: state => !!state.accessToken,
	},
};
